<template>
  <v-row class="pt-3">
    <!-- <v-col cols="6" sm="12" md="6" lg="3" class="pt-0 pb-0">
      <v-select
        v-model="keywordGroup"
        :items="itemSmall"
        item-value="groupId"
        item-text="groupCompanyNameTh"
        multiple
        outlined
        label="ชื่อเครือ"
        placeholder="ค้นหา ชื่อเครือ"
        class="mt-2"
        dense
        @change="searchFilterData()"
      >
      <template #selection="{ item }">
          <v-chip color="#EFF4FD !important" label small>
            <span class="filter-chip_department" style="color: #3776E9">{{item.groupCompanyNameTh}}</span>
          </v-chip>
        </template>
      </v-select>
    </v-col> -->
    <v-col cols="4" sm="4" md="4" lg="4" class="pt-0 pb-0">
      <span class="head-search-text">ชื่อเครือ</span>
      <v-select
        v-model="keywordGroup"
        :items="itemSmall"
        item-value="groupId"
        item-text="groupCompanyFullName"
        multiple
        outlined
        placeholder="ค้นหา ชื่อเครือ"
        class="mt-0"
        dense
        @change="searchFilterData()"
      >
        <template v-slot:prepend-item="{ item }" v-if="itemSmall.length > 1">
          <v-list-item
            ripple
            @click="toggle"
          >
            <v-list-item-action>
              <v-icon :color="keywordGroup.length > 0 ? 'indigo darken-4' : ''">
                {{ icon }}
              </v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                เลือกทั้งหมด {{item.groupCompanyNameTh}}
              </v-list-item-title>
              <v-sub-list-item-title>
                <span>name</span>
              </v-sub-list-item-title>
              <template v-slot:item="{ }">
                <span>test</span>
              </template>
              <!-- <v-list-group>
                <v-row>
                  <span absolute left class="text-left">test</span>
                </v-row>
                <v-btn absolute left icon x-small><v-icon>mdi-close</v-icon></v-btn>
              </v-list-group> -->
            </v-list-item-content>
          </v-list-item>
          <v-divider class="mt-0"></v-divider>
        </template>
        <!-- <template v-slot:item="{ item }">
          <v-list-item
            ripple
            @click="toggle"
          >
            <v-list-item-content>
              <v-list-item-title>
                เลือกทั้งหมด {{item}}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template> -->
        <template #selection="{ item, index }">
          <v-chip  v-if="index === 0" color="#EFF4FD !important" label small>
            <span v-if="keywordGroup.length !== itemSmall.length" class="filter-chip_department" style="color: #3776E9">{{item.groupCompanyFullName}}</span>
            <span v-else-if="keywordGroup.length === itemSmall.length" class="filter-chip_department" style="color: #3776E9">ทั้งหมด</span>
          </v-chip>
          <v-chip  v-if="index === 1 && keywordGroup.length !== itemSmall.length" color="#EFF4FD !important" label small>
            <span class="filter-chip_department" style="color: #3776E9">(+{{ keywordGroup.length - 1 }} เพิ่มเติม)</span>
          </v-chip>
        </template>
      </v-select>
    </v-col>
    <!-- <v-col cols="12" sm="6" md="6" lg="5" class="pt-0 d-flex align-end" style="padding-bottom: 1.5%;">
      <v-row class="pl-3 pr-3" style="margin-bottom: 0px;">
        <v-btn outlined color="primary" class="mr-5" style="min-height: 30px;" @click="searchFilterData()">ค้นหา</v-btn>
        <v-btn outlined color="primary" class="" style="min-height: 30px;" @click="resetFilterData()">ล้างข้อมูล</v-btn>
      </v-row>
    </v-col> -->
    <v-col cols="8" sm="8" md="8" lg="8" class="pt-0 pb-0 d-flex align-center justify-end mt-0">
      <v-btn
        outlined
        class="button-color ra-button-role-group"
        dark
        @click="gotocreate('เครือ')"
      >
        <v-icon left dark color="#fff" size="16px" class="">mdi-plus</v-icon>
        <span class="ra-text-in-button-role-group">
          เพิ่มสิทธิ์การใช้งาน
        </span>
      </v-btn>
    </v-col>
    <!-- <v-col cols="12" lg="4" md="6" sm="6" class="pt-0 pb-0 d-flex align-end">
      <v-row class="pl-3 pr-3" style="margin-bottom: 14px;">
        <v-btn class="btn-search-dep mr-5" style="min-height: 38px;" @click="searchFilterData()">ค้นหา</v-btn>
        <v-btn class="btn-reset-dep" style="min-height: 38px;" @click="resetFilterData()">ล้างข้อมูล</v-btn>
      </v-row>
    </v-col> -->
  </v-row>
</template>

<script>
import { EventBus } from '@/EventBus'

export default {
  name: 'filter-workgroup',
  data () {
    return {
      keywordGroup: [],
      keywordCompanyName: [],
      chkGroupName: '',
      memoryGroupName: [],
      filterData: {
        companyShortName: [],
        managementName: '',
        managementHeader: '',
        userName: '',
        userPosition: ''
      },
      itemSmall: [
        {
          groupId: '5f69da90f9e530261c0920b2',
          updateAt: '2021-07-09T11:45:56.767Z',
          groupCompanyNameTh: 'อินเทอร์เน็ตประเทศไทย',
          groupCompanyNameEng: 'INET',
          groupCompanyFullName: 'INET - อินเทอร์เน็ตประเทศไทย',
          subRole: [
            {
              id: '1',
              name: 'ลาป่วย'
            },
            {
              id: '2',
              name: 'ลากิจ'
            }
          ]
        },
        {
          groupId: '6008f734604bf3625ce8f23c',
          updateAt: '2021-06-14T03:25:42.917Z',
          groupCompanyNameTh: 'ทดสอบแก้ไข2',
          groupCompanyNameEng: 'testadd',
          groupCompanyFullName: 'testadd - ทดสอบแก้ไข2',
          subRole: [
            {
              id: '1',
              name: 'ลาบวช'
            },
            {
              id: '2',
              name: 'ลากิจ'
            }
          ]
        }
      ],
      itemLineWorkName: [],
      itemCompanyName: [],
      itemsSmallDep: [{
        id: 0,
        value: 0,
        label: 'INET'
      }, {
        id: 1,
        value: 1,
        label: 'MANDALA'
      }]
    }
  },
  computed: {
    selectAllGroup () {
      return this.keywordGroup.length === this.itemSmall.length
    },
    selectSomeGroup () {
      return this.keywordGroup.length > 0 && !this.selectAllGroup
    },
    icon () {
      if (this.selectAllGroup) return 'mdi-close-box'
      if (this.selectSomeGroup) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    }
  },
  watch: {
    keywordGroup: function (val) {
      if (val.length) {
        this.filterData.companyShortName = val
      }
      // EventBus.$emit('detailCompany', nodeId)
    }
  },
  beforeDestroy () {
    EventBus.$off('selectGroup')
    EventBus.$off('resetFilterRole')
  },
  mounted () {
    // EventBus.$on('getPosition', this.getSelectData)
    EventBus.$on('selectGroup', this.getSelectValue)
    EventBus.$on('resetFilterRole', this.resetFilterData)
  },
  methods: {
    toggle () {
      this.$nextTick(() => {
        if (this.selectAllGroup) {
          this.chkGroupName = false
          this.keywordGroup = []
        } else {
          this.chkGroupName = true
          this.keywordGroup = this.itemSmall.slice()
          for (let index = 0; index < this.keywordGroup.length; index++) {
            this.memoryGroupName = []
          }
          this.searchFilterData()
        }
      })
    },
    getSelectValue (data) {
      // this.itemSmall = data.compermission
      this.itemCompanyName = data.company
    },
    // getSelectData (data) {
    //   this.itemSmall = data.companyShortName
    //   this.itemCompanyName = data.companyName
    // },
    resetFilterData () {
      this.keywordGroup = ''
      this.keywordCompanyName = []
      this.filterData = {
        positionName: '',
        companyName: [],
        groupCompany: [],
        limit: 50,
        page: 1
      }
      EventBus.$emit('filterGroup', this.filterData)
    },
    searchFilterData () {
      this.filterData = {
        groupCompany: this.selectAllGroup === true ? this.memoryGroupName : this.keywordGroup,
        companyName: this.keywordCompanyName,
        limit: 50,
        page: 1
      }
      EventBus.$emit('filterGroup', this.filterData)
    },
    gotocreate (title) {
      this.$router.push('managerolecompany/createGroup')
    }
  }
}
</script>

<style scoped>
.v-input__slot {
  align-items: center;
  color: inherit;
  display: flex;
  margin-bottom: 0px !important;
  min-height: inherit;
  position: relative;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  width: 100%;
}

.v-text-field.v-text-field--enclosed .v-text-field__details {
  margin-bottom: 0px !important;
}

.v-text-field__details {
  min-height: 0px !important;
}

.theme--light.v-text-field--outlined > .v-input__control > .v-input__slot {
  /* font-family: 'Sarabun', sans-serif; */
  font-family: 'Sarabun', sans-serif !important;
  font-weight: normal;
  font-size: 14px;
}

.v-menu__content {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 14px;
}

.filter-chip_department {
  font-family: 'Sarabun', sans-serif;
  font-weight: bold;
  font-size: 14px;
  color: #fff;
}

.filter-title-textfield {
  font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px;
  color: #000;
}
.ra-button-role-group {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /* padding: 9px 24px; */

  position: absolute;
  width: 157px;
  height: 36px;

  /* Color / Primary / Default */

  background: #3776E9;
  border-radius: 4px;
}
.ra-text-in-button-role-group {
  font-family: 'Sarabun', sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
